import * as React from 'react';
import { Icon } from 'antd';
import { Separator } from '@ui/components';
import { RouteComponentProps, withRouter } from 'react-router';

import './PageNavigation.less';

class PageNavigation extends React.PureComponent<
  RouteComponentProps & { title: any; style?: any }
> {
  handleOpenHome = () => {
    const { history } = this.props;
    history.push('/home');
  };

  render() {
    const { children, title, style = {} } = this.props;
    return (
      <div className="page-navigation-menu" style={style}>
        <div className="page-navigation-menu__content">
          <Icon type="home" theme="filled" onClick={this.handleOpenHome} />
          <Separator />
          <span className="page-navigation-menu__content__title">{title}</span>
        </div>
        <div className="page-navigation-menu__panel">{children}</div>
      </div>
    );
  }
}

export default withRouter(PageNavigation);



// WEBPACK FOOTER //
// ./src/components/PageNavigation/PageNavigation.tsx